<template>
  <div>
    <div class="d-flex mb-4 justify-content-between align-items-center">
      <div>
        <h6 class="title">{{ $t('flexigo.flexiride.request.onDemand') }}</h6>
      </div>
      <div class="d-flex align-items-center gap-2">
        <custom-date
          v-model="selectedDate"
          :border="false"
          :newDays="days"
          @date-changed="onChange"
          @show-custom-range="onCustomRangeChange"
        />
        <div v-if="showCustomRange">
          <date-range-picker :start="startDate" :end="endDate" :locale="$i18n.locale" @selected="changeDate" />
        </div>
      </div>
    </div>
    <div class="row g-3">
      <div v-for="(item, index) in kpiItems" :key="item.id" class="col-12 col-md-6 col-lg-2">
        <kpi-box
          :icon="item.icon"
          :title="item.title"
          :description="item.description"
          :status-dot="item.statusDot"
          :height="index < 6 ? 155 : 175"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { startOfWeek, endOfWeek } from 'date-fns';
import DateRangePicker from '@vektor/date-picker';
import customDate from '../../../components/date.vue';
import kpiBox from './KpiBox.vue';

export default {
  name: 'KpiBoxes',
  components: {
    DateRangePicker,
    customDate,
    kpiBox,
  },
  data() {
    const today = new Date();

    return {
      selectedDate: 'thisWeek',
      showCustomRange: false,
      startDate: startOfWeek(today, { weekStartsOn: 1 }),
      endDate: endOfWeek(today, { weekStartsOn: 1 }),
      days: ['thisWeek', 'lastSevenDays', 'thisMonth', 'lastThirtyDays', 'lastMonth', 'customDate'],
    };
  },
  computed: {
    ...mapGetters('onDemandDashboard', {
      kpiItems: 'kpiItems',
    }),
  },
  created() {
    this.fetchKpiData({
      startDate: this.startDate,
      endDate: this.endDate,
    });
  },
  methods: {
    ...mapActions('onDemandDashboard', ['fetchKpiData']),

    async onChange(e) {
      this.startDate = typeof e.fromDate === 'string' ? new Date(e.fromDate) : e.fromDate;
      this.endDate = typeof e.toDate === 'string' ? new Date(e.toDate) : e.toDate;

      await this.fetchKpiData({
        startDate: this.startDate,
        endDate: this.endDate,
      });
    },
    onCustomRangeChange(data) {
      this.showCustomRange = data;
    },
    async changeDate(date) {
      const startDate = date.raw?.startDate || date.start || date.startDate;
      const endDate = date.raw?.endDate || date.end || date.endDate;

      this.startDate = typeof startDate === 'string' ? new Date(startDate) : startDate;
      this.endDate = typeof endDate === 'string' ? new Date(endDate) : endDate;

      await this.fetchKpiData({
        startDate: this.startDate,
        endDate: this.endDate,
      });
    },
  },
};
</script>

<style scoped>
.title {
  color: #363647;
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 0;
}
</style>
